import { nanoid } from 'nanoid'

export const SEGMENTS_URBAN_OR_WALKABLE_THOROUGHFARE = {
  DEFAULT_BUILDING_HEIGHT_LEFT: 2,
  DEFAULT_BUILDING_HEIGHT_RIGHT: 2,
  DEFAULT_BUILDING_VARIANT_LEFT: 'wide',
  DEFAULT_BUILDING_VARIANT_RIGHT: 'narrow',
  segments: [
    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 5.5,
      id: nanoid()
    },
    {
      type: 'sidewalk',
      variant: { 'sidewalk-density': 'normal' },
      width: 6,
      id: nanoid()
    },
    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 20,
      id: nanoid()
    },

    {
      type: 'drive-lane',
      variant: {
        direction: 'inbound',
        'car-type': 'car'
      },
      width: 12,
      id: nanoid()
    },
    {
      type: 'drive-lane',
      variant: {
        direction: 'inbound',
        'car-type': 'car'
      },
      width: 11,
      id: nanoid()
    },
    {
      type: 'turn-lane',
      variant: { direction: 'outbound|shared' },
      width: 11,
      id: nanoid()
    },

    {
      type: 'drive-lane',
      variant: {
        direction: 'outbound',
        'car-type': 'car'
      },
      width: 11,
      id: nanoid()
    },
    {
      type: 'drive-lane',
      variant: {
        direction: 'outbound',
        'car-type': 'car'
      },
      width: 12,
      id: nanoid()
    },
    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 20,
      id: nanoid()
    },
    {
      type: 'sidewalk',
      variant: { 'sidewalk-density': 'normal' },
      width: 6,
      id: nanoid()
    },

    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 5.5,
      id: nanoid()
    }
  ]
}
